import { Route, withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import trackingService from 'services/UITrackingService';

import ErrorBoundary from './ErrorBoundary';


@withRouter
export default class TrackedRoute extends Component {

  static propTypes = { render: PropTypes.func };
  static defaultProps = { render: undefined };

  decoratedRender = (props) => {
    trackingService.emit('routeMatched', props);

    return this.props.render(props);
  };

  render() {
    const otherProps = {};
    if (this.props.render) {
      otherProps.render = this.decoratedRender;
    }

    return (
      <ErrorBoundary>
        <Route {...this.props} {...otherProps} />
      </ErrorBoundary>
    );
  }
}
